import { ApiProperty } from "@nestjs/swagger";

export class SuggestPalletRequest {
    @ApiProperty()
    saleOrderId: number;
   
    @ApiProperty()
    saleOrderItemId: number;
   
    @ApiProperty()
    reportingQty: number;
    // @ApiProperty()
    // palletType?: string;
   
  }
